module.exports = __webpack_public_path__ + "static/media/arrow-right.750bd27b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-right.svg
// module id = 166
// module chunks = 0